import React from 'react';

import { AnimationTypeSelectorButtonGroupText } from './AnimationTypeSelectorButtons';
import { useAnimationStageContext } from './AnimationStageContext';

const DrawTypeChoiceButton = () => {
  const { getSelectedDrawTypeChoice } = useAnimationStageContext();

  const { label, icon } = getSelectedDrawTypeChoice();

  return (
    <>
      {icon}
      <AnimationTypeSelectorButtonGroupText>{label}</AnimationTypeSelectorButtonGroupText>
    </>
  );
};

export default DrawTypeChoiceButton;
